import { Loader, LoaderOptions } from "google-maps"

const options: LoaderOptions = {}
const mapElements = document.querySelectorAll<HTMLElement>('.js-google-map')
let apiKey = ""

mapElements.forEach((element) => {
  if (element.dataset.apiKey) apiKey = element.dataset.apiKey
})

const loader = new Loader(apiKey, options)

const loadGoogleMaps = async (): Promise<typeof google> => {
  if (window.google && window.google.maps) {
    console.log("Google Maps API is already loaded.")
    return window.google
  }

  console.log("Loading Google Maps API...")
  return await loader.load()
}

export default loadGoogleMaps
